// extracted by mini-css-extract-plugin
export default {"inputNumberFilter":"InputNumberFilter_inputNumberFilter__-B-CP","label":"InputNumberFilter_label__G7b9y","input":"InputNumberFilter_input__VSCdB"};